import CryptoJS from 'crypto-js'

// 加密
export function Encrypt(word: string, keyStr: string): string {
  keyStr = keyStr ? keyStr : 'OFDSVXZ34FDS3Y8C'
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

// 解密
export function Decrypt(word: string, keyStr?: string): string {
  keyStr = keyStr ? keyStr : 'OFDSVXZ34FDS3Y8C'
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return decrypt.toString(CryptoJS.enc.Utf8)
}
